import React from "react";
import DeliveryHealth from "../components/DeliveryHealth/DeliveryHealth";

export default function DeliveryHealthView() {
  return <DeliveryHealth />;
}
